<template>
    <!--弹窗-->
    <el-dialog
        width="850px"
        title="分配采购人员"
        :visible.sync="visible"
        :before-close="handleClose"
        top="5vh"
        append-to-body
    >
        <el-table
            :row-key="getRowKeys"
            v-loading="loading"
            :data="list"
            class="table_content"
            size="mini"
            border
            height="400"
            style="width: 100%;">
            <el-table-column label="选中情况" width="100" align="center">
                <template slot-scope="scope">
                    <el-checkbox v-model="scope.row.selected == 1" @change="changeCheckBox(scope.row, scope.$index)"></el-checkbox>
                </template>
            </el-table-column>
            <el-table-column
                label="id"
                :resizable="false"
                prop="id"
                align="center">
            </el-table-column>
            <el-table-column
                label="用户账号"
                :resizable="false"
                prop="username"
                align="center">
            </el-table-column>
            <el-table-column
                min-width="140"
                label="用户名"
                :resizable="true"
                prop="full_name"
                align="center">
            </el-table-column>
        </el-table>

        <el-row style="margin-top:17px; ">
            <el-button
                style="float:right;margin-left:6px;"
                size="mini"
                v-show="showDistributionPeople"
                @click="handleClose(true)">分 配
            </el-button>
            <el-button
                style="float:right;margin-left:6px;"
                size="mini"
                type="danger"
                @click="handleClose()">取 消
            </el-button>
        </el-row>
    </el-dialog>
</template>
<script>
import * as api from '@/api/advAnalys/advAnalys.js'
import {manager_build_selection_assign_developer} from '@/api/advAnalys/advAnalys.js'
// import addRootCategoryl from './addRootCategoryl.vue'

export default {
    data() {
        return {
            showAddRootCategoryl: false,
            list: [],
            loading: false,
            query: {
                state: '',
                name: ''
            },
        }
    },
    props: {
        visible: {
            type: Boolean,
            default: false
        },
        subLibraryDetailInfo: {
            type: Object,
            default: {}
        },
    },
    watch: {
        'visible': {
            handler(val) {
                val && this.getCategoryList()
            }
        }
    },
    computed: {
        showDistributionPeople(){
            return this.$checkPermission('admin/manager/cost_analysis/manager_batch_distribution')
        },
    },
    methods: {
        changeCheckBox(data, index){
            for(const listIndex in this.list) {
                if(listIndex == index) {
                    this.$set(this.list[listIndex], 'selected',1)
                } else {
                    this.$set(this.list[listIndex], 'selected',0)
                }
            }
            // this.$set(this.list[index], 'selected', this.list[index].selected == 0 ? 1 : 0)
        },
        //分页
        handleCurrentChange(val) {
            this.query.page = val
            this.getCategoryList()
        },
        handleSizeChange(val) {
            this.query.limit = val
            this.getCategoryList()
        },
        closeCllback(isshow) {
            this.showAddRootCategoryl = false
            isshow == true && this.getCategoryList()
        },
        getRowKeys(row) {
            return row.id
        },
        addFunc() {
            this.showAddRootCategoryl = true
        },
        getCategoryList() {
            this.loading = true
            api.manager_index_get_developer_list().then(res => {
                if (res.code === 0) {
                    this.list = (res.data || []).map(item=>{
                        item.selected = false
                        return item
                    })
                } else {
                    this.$message({type: 'error', message: res.message})
                }
            }).finally(() => {
                this.loading = false
            })
        },
        // 关闭弹窗
        handleClose(getIds = false) {
            let tempObj = {id: '', full_name:''}
            if(getIds) {
                for(const item of this.list) {
                    if(item.selected == 1) {
                        tempObj = item
                    }
                }
                if(tempObj.id) {
                    this.$confirm(`确认是否将分库分配给${tempObj.full_name}?`, {
                        confirmButtonText: '确定',
                        cancelButtonText: '取消',
                        type: 'warning'
                    }).then(() => {
                        this.loading = true
                        api.manager_build_selection_assign_developer({
                            id: this.subLibraryDetailInfo.id,
                            developer_id: tempObj.id
                        }).then(res => {
                            if (res.code === 0) {
                                this.$message.success('分配成功')
                                this.$emit('close-callback', true)
                            } else {
                                this.$message({type: 'error', message: res.message})
                            }
                        }).finally(() => {
                            this.loading = false
                        })
                    }).catch(() => {
                    })
                } else {
                    this.$message({type: 'error', message:'暂未选择人员'})
                }
            } else {
                this.$emit('close-callback')
            }
        },
    }
}
</script>
<style type="text/scss" lang="scss" scoped>
.content {
    display: flex;
    justify-content: space-between;
    border-top: 1px solid #cecfd1;
    font-size: 12px;
    color: #000;

    .shu {
        border-right: 1px solid #cecfd1;
    }

    .content-div {
        width: 50%;
        padding: 25px 20px;
    }

    .content-buttom {
        display: flex;
        justify-content: space-between;
        border-bottom: 1px solid #cecfd1;
        padding-bottom: 8px;
        margin-bottom: 10px;
    }

    .content-buttom-txet {
        color: rgb(57, 187, 252);
        cursor: pointer;
    }

    .content-data {
        width: 100%;
        height: 230px;
        overflow: auto;

        .content-list {
            display: flex;
            justify-content: space-between;
            align-items: center;
            margin: 10px 0;

            .cha {
                cursor: pointer;
                font-size: 15px;
                color: rgb(158, 192, 209);
                margin: 0 10px 0 12px;
            }
        }
    }

    /deep/ .content-data::-webkit-scrollbar {
        width: 3px;
        height: 5px;
        border-radius: 15px;
        -webkit-border-radius: 15px;
    }

    /deep/ .content-data::-webkit-scrollbar-track-piece {
        background-color: #ffff;
        border-radius: 15px;
        -webkit-border-radius: 15px;
    }

    /deep/ .content-data::-webkit-scrollbar-thumb:vertical {
        height: 5px;
        background-color: rgba(144, 147, 153, 0.5);
        border-radius: 15px;
        -webkit-border-radius: 15px;
    }

    /deep/ .content-data::-webkit-scrollbar-thumb:horizontal {
        width: 3px;
        background-color: rgba(144, 147, 153, 0.5);
        border-radius: 15px;
        -webkit-border-radius: 15px;
    }
}

.media-txt {
    font-size: 15px;
    color: #6a6c6f;
    font-weight: 600;
    margin-bottom: 8px;
}

/deep/ .el-dialog__body {
    padding: 0px 20px 20px 20px !important;
}

/deep/ .el-form-item {
    margin-bottom: 12px !important;
}
</style>
